import React, { Component } from 'react';
import $ from 'jquery';
import WalletAddress from './../functions/wallet_address.js';
import SendTransaction from './../functions/send_transaction.js';
import DAOLevel from './../functions/daolevel';

export default class AiDAO extends Component {

  render() {
    var kyc = window.kyc;
    var pass = window.pass;
    var limit = window.allowance;
    var data = this.props.data.aidao;

    // cancel the && pass === "True" to enable everyone dao sending
    if (kyc > 2) {
      $(document).ready(function() {
        $("#dao-page-card").html(
            `<button class="btn btn-green w-md waves-effect waves-light" data-toggle="modal" data-target="#con-close-modal">Send</button>`
        );

        //$("#limit-allowance").html(`Your monthly AiDAO sending limit is ` + limit + ` AiDAO`);
      });
    }

    return (

        <div>

            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="card-box">
                        <h4 class="header-title m-t-0 m-b-30">AiDAO {data.balance}</h4>

                        <div class="widget-box-2">
                            <DAOLevel data={this.props.data.daolevel}/>
                            <div id="dao-page-card" class="text-right m-t-10"></div>
                            <div id="limit-allowance"></div>

                            <SendTransaction name="aidao" data={this.props.data.send_transaction}/>

                        </div>

                    </div>

                </div>

            </div>
            <WalletAddress data={this.props.data.wallet_address}/>
    </div>


    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/cryptos/aidao.js